export const outbrainMixins: Record<string, Partial<OutbrainProps>> = {
  AR_35: {
    widgetId: 'AR_35',
  },
  AR_36: {
    widgetId: 'AR_36',
  },
  AR_37: {
    widgetId: 'AR_37',
  },
  AR_45: {
    widgetId: 'AR_45',
  },
  AR_38: {
    widgetId: 'AR_38',
  },
  AR_44: {
    widgetId: 'AR_44',
  },
  AR_27: {
    widgetId: 'AR_27',
  },
  SB_2: {
    //siderail
    widgetId: 'SB_2',
  },
  AR_31: {
    //below thumbnails
    widgetId: 'AR_31',
  },
  AR_2: {
    // article_rec_feed
    widgetId: 'AR_2',
  },
  AR_4: {
    // newtab_leaderboard_mb
    widgetId: 'AR_4',
  },
  AR_7: {
    // article_hero
    widgetId: 'AR_7',
  },
  AR_9: {
    // article_content_middle
    widgetId: 'AR_9',
  },
  AR_51: {
    // article_siderail_top
    widgetId: 'AR_51',
  },
  AR_52: {
    // article_siderail_middle
    widgetId: 'AR_52',
  },
  AR_53: {
    // article_siderail_bottom
    widgetId: 'AR_53',
  },
  AR_54: {
    // article_content_top
    widgetId: 'AR_54',
  },
  AR_55: {
    // article_content_below_image
    widgetId: 'AR_55',
  },
  AR_56: {
    // article_content_above_button
    widgetId: 'AR_56',
  },
  AR_57: {
    // newtab_r4_c1
    widgetId: 'AR_57',
  },
  AR_58: {
    // newtab_r4_right
    widgetId: 'AR_58',
  },
  AR_59: {
    // newtab_leaderboard
    widgetId: 'AR_59',
  },
  AR_60: {
    // article_hero_mb
    widgetId: 'AR_60',
  },
  AR_61: {
    // article_content_middle_mb
    widgetId: 'AR_61',
  },
  AR_62: {
    // sectiontab_300x250
    widgetId: 'AR_62',
  },
  AR_63: {
    // sectiontab_600x600
    widgetId: 'AR_63',
  },
}
